import classNames from 'classnames';
import { t } from 'ttag';

import DiscountFilledIcon from '@svg/discount-filled.svg';
import UaFlagIcon from '@svg/ua-flag.svg';
import DeliveryIcon from '@svg/free-delivery.svg';
import { Button } from '@ui/Button';

// styles
import s from './FeedTagFilter.sss';

export interface TagFilter {
  label: () => string,
  icon: React.ReactNode,
  value: 'isOnSale' | 'freeShipping' | 'ukrainian',
}

const FILTERS: TagFilter[] = [
  {
    label: () => t`Знижка`,
    icon: (
      <DiscountFilledIcon
        className={s.icon}
        width='24'
        height='24'
        fill='#F993B9'
      />
    ),
    value: 'isOnSale',
  },
  {
    label: () => t`Безкоштовна доставка`,
    icon: (
      <DeliveryIcon
        className={s.icon}
        width='24'
        height='24'
      />
    ),
    value: 'freeShipping',
  },
  {
    label: () => 'Зроблено в Україні',
    icon: (
      <UaFlagIcon
        className={s.icon}
        width='24'
        height='24'
      />
    ),
    value: 'ukrainian',
  },
];

interface Props {
  className?: string,
  value: {
    freeShipping?: boolean,
    isOnSale?: boolean,
    ukrainian?: boolean,
  },
  isFreeShippingEnabled?: boolean;
  isOnSaleEnabled?: boolean;
  isUkrainianEnabled?: boolean;
  onClick: (value: TagFilter['value']) => void,
}

export const FeedTagFilter: React.FC<Props> = ({
  className,
  value,
  isFreeShippingEnabled = true,
  isOnSaleEnabled = true,
  isUkrainianEnabled = true,
  onClick,
}) => (
  <ul className={classNames(s.list, className)}>
    {FILTERS.map(({ label, icon, value: filterValue }) => {
      if (
        (filterValue === 'freeShipping' && isFreeShippingEnabled)
        || (filterValue === 'isOnSale' && isOnSaleEnabled)
        || (filterValue === 'ukrainian' && isUkrainianEnabled)
      ) {
        return (
          <li
            key={filterValue}
            className={s.item}
          >
            <Button
              className={classNames(s.button, {
                [s.buttonStateActive]: value[filterValue],
              })}
              theme="secondary"
              onClick={() => onClick(filterValue)}
            >
              {icon}
              <span className={s.label}>
                {label()}
              </span>
            </Button>
          </li>
        );
      }


      return null;
    })}
  </ul>
);
